<template>
  <div class="user-container">
    <div class="content">
      <el-tabs type="card" v-model="activeName" class="content-tab">
        <el-tab-pane
          label="公司账号"
          name="公司账号"
          v-if="getPermission('用户管理-公司账号管理', '查看')"
          :beforeurl="beforeUrl"
        >
          <Company ref="company" />
        </el-tab-pane>
        <el-tab-pane
          label="部门账号"
          name="部门账号"
          v-if="getPermission('用户管理-部门账号', '查看')"
          :beforeurl="beforeUrl"
        >
          <Dept ref="dept" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Company from './components/company.vue'
import Dept from './components/dept.vue'
export default {
  components: {
    Company,
    Dept
  },
  data () {
    return {
      activeName: '公司账号',
      beforeUrl: '',
    }
  },
  methods: {
    getPermission (val1, val2) {
      const permission = this.$store.state.home.permission
      let flag = true
      permission.map(menu => {
        if (menu.menuName === val1) {
          menu.permissions.map(per => {
            if (per.annotation === val2) {
              if (per.status === 0) {
                flag = false
                if (val1 === '用户管理-公司账号管理') {
                  this.activeName = '部门账号'
                } else {
                  this.activeName = '公司账号'
                }
              }
            }
          })
        }
      })
      return flag
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.beforeUrl = from.path.split('/')[1]
    })
  },
  watch: {
    beforeUrl () {
      if (this.beforeUrl == 'gotoOther') {
        return
      }
      this.$nextTick(() => {
        if (this.beforeUrl !== 'user') {
          if (this.$refs.company) {
            this.$refs.company.getCompanyData()
          }
          if (this.$refs.dept) {
            this.$refs.dept.getCompanyData()
          }
        } else {
          if (this.$refs.company) {
            this.$refs.company.getTableData()
          }
          if (this.$refs.dept) {
            this.$refs.dept.getTableData()
          }
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.beforeUrl = 'gotoOther'
    next()
  }
}
</script>

<style lang="less" scoped>
.user-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.equipment-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
.el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__content {
    flex: 1;
  }
  .el-tab-pane {
    height: 100%;
  }
}
.content-tab {
  .el-tabs__item {
    background-color: #e3e3e3;
    color: #7f7f7f;
  }
  .el-tabs__header .el-tabs__item.is-active {
    background-color: #409eff;
    color: #fff;
    border-bottom-color: #e4e7ed;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 0;
  }
}
</style>
